import { render } from "./CouponModal.vue?vue&type=template&id=1c463916"
import script from "./CouponModal.vue?vue&type=script&lang=js"
export * from "./CouponModal.vue?vue&type=script&lang=js"

import "./CouponModal.vue?vue&type=style&index=0&id=1c463916&lang=scss"
script.render = render

export default script